<template>
  <div class="dash-view dash-create pb-0">
    <div class="chart-wrap">
      <div v-for="(chart, index) in droppedCharts" :key="index" class="chart-column drag-drop-zone"
        @dragover.prevent="setDragging(index, true)" @dragleave.prevent="setDragging(index, false)"
        @drop.prevent="handleDrop($event, index)" draggable="true" @dragstart="startDrag($event, chart, index)"
        :class="{ 'is-dragging': draggingStates[index] }">
        <!-- <div class="dash-chart" v-if="loading[index]"> -->
        <DashboardCharts v-if="loading[index]" />
        <!-- </div> -->
        <p v-if="!chart">Drag and Drop your desired plots here</p>
        <div v-else>
          <h6 class="chart-name-top" v-if="!loading[index] && droppedCharts[index]?.Name">
            {{ droppedCharts[index].Name }}
          </h6>
          <div :ref="'chart_' + index" class="chart-main"></div>
        </div>
        <v-dialog v-model="isPreviewOpen[index]" class="multi-chart-preview-div dashboard-chart-preview composition">
          <v-card class="position-relative studio-card dashboard-card">
            <template v-if="
              chart?.ChartType === 'Scatter Plot' ||
              chart?.ChartType === 'Line Plot'
            ">
              <div class="modal-tab-div">
                <div class="tab-div justify-center">
                  <p>X Axis Scale</p>
                  <v-btn-toggle v-model="isModalXLog" class="axis-toggle" mandatory
                    @update:modelValue="handleModalXScaleToggleChange">
                    <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                  </v-btn-toggle>
                </div>
                <div class="tab-div justify-center">
                  <p>Y Axis Scale</p>
                  <v-btn-toggle v-model="isModalYLog" class="axis-toggle" mandatory
                    @update:modelValue="handleModalYScaleToggleChange">
                    <v-btn class="switch-btn" :value="true" outlined>Log</v-btn>
                    <v-btn class="switch-btn" :value="false" outlined>Linear</v-btn>
                  </v-btn-toggle>
                </div>
              </div>
            </template>
            <v-card-text>
              <div class="popup-top">
                <div class="chart-name-top w-100">
                  <h6>{{ chart?.Name }}</h6>
                </div>
                <!-- <img :src="cross" alt="cross" @click="closeModal(index)" class="chart-preview-close-btn"> -->
              </div>
              <div ref="modal_chart_" class="modal-chart-container"></div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <v-snackbar v-model="showAlert" color="#E53535" timeout="5000">
      Error : {{ errorMessage }}
    </v-snackbar>
    <v-snackbar v-model="showSuccess" color="#4CAF50" timeout="5000">
      Success : {{ successMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist-min";
import api from "../../../axiosInterceptor";
import { getDisplayNameDashboard } from "../../../utils/cache";
import DashboardCharts from "../Loaders/DashboardCharts.vue";
import Expand from "../../../assets/Svg/Chart/expand-btn.svg";
import downloadIcon from "../../../assets/Svg/Chart/csv_chart.svg";
import { eventBus } from "../../../eventBus.js";
import { mapGetters } from "vuex";
import { formatNumber, shouldFormatNumbers, createPlotlyTickFormat, createCustomTickFormatter } from "../../../utils/numberFormatter";

export default {
  name: "DashboardView",
  components: {
    DashboardCharts,
  },
  data() {
    return {
      duplicate: require("../../../assets/Svg/Dashboard/duplicate.svg"),
      cross: require("../../../assets/Svg/Chart/chart-cross.svg"),
      camIcon: require("../../../assets/Svg/camIcon.svg"),
      draggingStates: {},
      droppedCharts: Array(6).fill(null), // Max 6 charts
      previousDroppedCharts: Array(6).fill(null), 
      tableData: [],
      selectedColorGroupKeys: [],
      selectedYAxisKeys: [],
      selectedXAxisKeys: [],
      selectedZAxisKeys: [],
      updatedXColumnDisplayName: [],
      updatedYColumnDisplayName: [],
      updatedGroupColumnDisplayName: [],
      isPreviewOpen: [],
      loading: [],
      xBins: [],
      yBins: [],
      markerSizes: [],
      xAxisScaleModal: "linear",
      yAxisScaleModal: "linear",
      isModalXLog: false,
      isModalYLog: false,
      dashboard_id: "",
      showAlert: false,
      showSuccess: false,
      errorMessage: "",
      successMessage: "",
      expandedIndex: null,
    };
  },
  props: {
    name: {
      type: String,
      default: "untitled",
    },
    accessLevel: {
      type: String,
      default: "private",
    },
    isDefault: {
      type: Boolean,
      default: false,
    },
    charts: {
      type: Array,
      default: false,
    },
    dashboardID: {
      type: String,
    },
    isEditing: {
      type: Boolean,
      required: true
    }
  },
  watch: {
  charts: async function (newValue) {
    this.previousDroppedCharts = [...this.droppedCharts]; // Store previous state
    this.droppedCharts = Array(6).fill(null);

    for (let index = 0; index < 6; index++) {
      if (index < newValue.length) {
        this.droppedCharts[index] = newValue[index];
        await this.fetchChartsData(newValue[index], index);
      } else {
        this.droppedCharts[index] = null;
        this.renderChart(null, index, "chart_");
      }
    }
  },
  name: function (newValue, oldValue) {
    if (newValue !== oldValue) {
      if (!this.droppedCharts.every(chart => chart === null)) {
        this.updateDashboard();
      }
    }
  },
  accessLevel: function () {
    if (!this.droppedCharts.every(chart => chart === null)) {
      this.updateDashboard();
    }
  },
  isDefault: function () {
    if (!this.droppedCharts.every(chart => chart === null)) {
      this.updateDashboard();
    }
  },
  dashboardID: function (newValue) {
    this.dashboard_id = newValue;
  },
  // Watch for dark mode changes to reload plots and update grid colors
  isDarkMode() {
    this.reloadAllCharts();
  }
},

  methods: {
    getColorForIndex(index) {
      const colors = [
        "rgba(0, 100, 250, 0.8)",   // Blue
        "rgba(255, 99, 71, 0.8)",   // Red
        "rgba(50, 205, 50, 0.8)",   // Green
        "rgba(255, 215, 0, 0.8)",   // Gold
        "rgba(147, 112, 219, 0.8)", // Purple
        "rgba(255, 165, 0, 0.8)"    // Orange
      ];
      return colors[index % colors.length];
    },

    // Dynamic height calculation methods
    calculateChartHeight() {
      const screenHeight = window.innerHeight;
      const screenWidth = window.innerWidth;
      // Get zoom level (approximate)
      const zoomLevel = window.devicePixelRatio || 1;
      let baseHeight = 500; // Default
      
      // Adjust height based on screen size with zoom consideration
      if (screenHeight >= 1080) {
        // Large screens (1080p and above) - reduce height to account for zoom
        baseHeight = Math.min(screenHeight * 0.5, 700); 
      } else if (screenHeight >= 768) {
        // Medium screens (768p to 1079p)
        baseHeight = Math.min(screenHeight * 0.45, 550); 
      } else {
        // Small screens (below 768p)
        baseHeight = Math.min(screenHeight * 0.4, 450); 
      }
      
      // Further reduce height if zoom level is high
      if (zoomLevel > 1) {
        baseHeight = baseHeight * 0.9; 
      }
      
      // Ensure minimum height
      return Math.max(baseHeight, 300); 
    },
    calculateModalChartHeight() {
      const screenHeight = window.innerHeight;
      const screenWidth = window.innerWidth;
      // Get zoom level (approximate)
      const zoomLevel = window.devicePixelRatio || 1;
      let baseHeight = 600;
      
      if (screenHeight >= 1080) {
        baseHeight = Math.min(screenHeight * 0.6, 800); 
      } else if (screenHeight >= 768) {
        // Medium screens (768p to 1079p)
        baseHeight = Math.min(screenHeight * 0.55, 650); 
      } else {
        // Small screens (below 768p)
        baseHeight = Math.min(screenHeight * 0.5, 550); 
      }
      
      // Further reduce height if zoom level is high
      if (zoomLevel > 1) {
        baseHeight = baseHeight * 0.9; 
      }
      
      // Ensure minimum height for modal
      return Math.max(baseHeight, 380); 
    },

    // Handle window resize for dynamic height calculation
    handleResize() {
      // Re-render all charts with new height calculations
      this.droppedCharts.forEach((chart, index) => {
        if (chart && this.dataLoaded && this.dataLoaded[index]) {
          this.renderChart(chart, index, "chart_");
        }
      });
    },

  resetDashboardState() {
    this.draggingStates = {};
    this.previousDroppedCharts = Array(6).fill(null);
    this.droppedCharts = Array(6).fill(null);
    this.tableData = [];
    this.selectedColorGroupKeys = [];
    this.selectedYAxisKeys = [];
    this.selectedXAxisKeys = [];
    this.selectedZAxisKeys = [];
    this.updatedXColumnDisplayName = [];
    this.updatedYColumnDisplayName = [];
    this.updatedGroupColumnDisplayName = [];
    this.isPreviewOpen = [];
    this.loading = [];
    this.xBins = [];
    this.yBins = [];
    this.xAxisScaleModal = "linear";
    this.yAxisScaleModal = "linear";
    this.isModalXLog = false;
    this.isModalYLog = false;
    this.dashboard_id = "";
    this.showAlert = false;
    this.showSuccess = false;
  },

  handleModalXScaleToggleChange() {
    this.xAxisScaleModal = this.isModalXLog ? "log" : "linear";
  },

  handleModalYScaleToggleChange() {
    this.yAxisScaleModal = this.isModalYLog ? "log" : "linear";
  },

  // Reload all charts when dark mode changes to update grid colors
  reloadAllCharts() {
    this.droppedCharts.forEach((chart, index) => {
      if (chart && this.dataLoaded[index]) {
        this.renderChart(chart, index, "chart_");
      }
    });
  },

  setDragging(index, isDragging) {
    this.draggingStates[index] = isDragging;
  },

  startDrag(event, chart, oldIndex = null) {
    event.dataTransfer.setData("chart", JSON.stringify(chart));
    event.dataTransfer.setData("oldIndex", oldIndex); // Save old position if dragging a dropped chart
  },

  async handleDrop(event, newIndex) {
  this.setDragging(newIndex, false);

  try {
    const chartData = event.dataTransfer.getData("chart");
    const oldIndex = event.dataTransfer.getData("oldIndex");
    const chart = JSON.parse(chartData);

    if (!chart || !chart.Name) return;

    this.previousDroppedCharts = JSON.parse(JSON.stringify(this.droppedCharts));

    if (oldIndex !== "null" && oldIndex !== "" && oldIndex !== null) {
      const movedChart = this.previousDroppedCharts[newIndex];

      if (movedChart && movedChart.Name) {
        this.droppedCharts[oldIndex] = null;
        this.$nextTick(() => {
          this.droppedCharts[oldIndex] = movedChart;
          this.droppedCharts[oldIndex].Name = movedChart.Name; // ✅ Name ensure karo

          this.droppedCharts[newIndex] = chart;
          this.droppedCharts[newIndex].Name = chart.Name; // ✅ Name ensure karo

          this.fetchChartsData(movedChart, oldIndex);
          this.fetchChartsData(chart, newIndex);
          this.updateDashboard(chart);
        });
      }
    } else {
      if (this.droppedCharts[newIndex]) {
        const availableIndex = this.previousDroppedCharts.findIndex(c => c === null);
        if (availableIndex !== -1) {
          this.droppedCharts[availableIndex] = this.previousDroppedCharts[newIndex];
          this.$nextTick(() => {
            this.droppedCharts[newIndex] = chart;
            this.droppedCharts[newIndex].Name = chart.Name; // ✅ Name ensure karo

            this.fetchChartsData(chart, newIndex);

            const isFirstDrop = this.droppedCharts.filter(c => c !== null).length === 1;
            if (isFirstDrop) {
              this.createDashboard(chart, newIndex);
            } else {
              this.updateDashboard(chart);
            }
          });
        } else {
          return;
        }
      } else {
        this.$nextTick(() => {
          this.droppedCharts[newIndex] = chart;
          this.droppedCharts[newIndex].Name = chart.Name; // ✅ Name ensure karo

          this.fetchChartsData(chart, newIndex);

          const isFirstDrop = this.droppedCharts.filter(c => c !== null).length === 1;
          if (isFirstDrop) {
            this.createDashboard(chart, newIndex);
          } else {
            this.updateDashboard(chart);
          }
        });
      }
    }

    eventBus.emit("chart-Get-removed", chart);
  } catch (error) {
    console.error("Error parsing chart data:", error);
  }
}
,  
    updateDashboard() {
      const tenantId = localStorage.getItem("tenantId");
      const dashboardId = this.dashboard_id;
      this.loading = true;
      if (!dashboardId) {
    this.$emit("show-snackbar", "Dashboard can't be created");
    return;
  }
      const sanitizedChartsID = Array.isArray(this.droppedCharts)
        ? this.droppedCharts.filter((chart) => chart && chart.ID).map((chart) => chart.ID)
        : [];

      const requestBody = {
        Data: {
          dashboard: {
            name: this.name,
            chartsID: sanitizedChartsID,
            AccessLevel: this.accessLevel,
            isDefault: this.isDefault,
          },
        },
      };

      api
        .put(
          process.env.VUE_APP_API_URL + "public/api/dashboards/" + dashboardId,
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "X-TenantID": tenantId,
            },
          }
        )
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            if (this.name) {
              localStorage.setItem("dashboard", this.name)
              // Set the updated dashboard name to be prioritized when returning to list
              localStorage.setItem("newlyCreatedDashboard", this.name);
            }
            if (this.isDefault) {
              localStorage.setItem("defaultDashboard", this.name);
            }
            const getDashboard = localStorage.getItem("dashboard");
            const getDefault = localStorage.getItem("defaultDashboard");
            if (getDashboard === getDefault && this.isDefault === false) {
              localStorage.removeItem("defaultDashboard")
            }
            this.loading = false;
            this.successMessage = "Dashboard updated.";
            this.showSuccess = true;
          }
          else if (response && response.data && response.data.message) {
            console.error(response.data.message);
            this.errorMessage = response.data.message;
            this.showAlert = true;
          }
          else {
            console.error("Error while updating dashboard");
            this.errorMessage = "Error while updating dashboard";
            this.showAlert = true;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage = "Error while updating dashboard";
          this.showAlert = true;
        })
        .finally(() => {
          this.hideExpand = false;
        });
    },
    createDashboard(chart, index) {
      const tenantId = localStorage.getItem("tenantId");

      const requestBody = {
        Data: {
          dashboard: {
            name: this.name,
            chartsID: [chart.ID],
            AccessLevel: this.accessLevel,
            isDefault: this.isDefault,
          },
        },
      };

      api
        .post(
          process.env.VUE_APP_API_URL + "public/api/dashboards",
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "X-TenantID": tenantId,
            },
          }
        )
        .then((response) => {
          if (
            response &&
            response.data &&
            (response.data.statusCode === 200 ||
              response.data.statusCode === 201)
          ) {
            this.dashboard_id = response.data.data.ID;
            const dashboardData = response.data.data;
            this.$emit("dashboard-id", dashboardData);
            if (this.name) {
              localStorage.setItem("dashboard", this.name)
            }
            if (this.isDefault) {
              localStorage.setItem("defaultDashboard", this.name);
            }
            this.successMessage = "Dashboard created successfully.";
            this.showSuccess = true;
          } else if (response && response.data && response.data.message) {
            this.errorMessage = response.data.message;
            this.showAlert = true;
          } else {
            this.errorMessage = "Error while creating dashboard";
            this.showAlert = true;
          }
        })
        .catch((error) => {
          this.errorMessage = error;
          this.showAlert = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // plotChart(index) {
    //   const container = this.$refs.chart_[index];
    //   if (!container) return;

    //   const trace = {
    //     x: [1, 2, 3, 4, 5],
    //     y: [Math.random() * 10, 8, 6, 5, Math.random() * 10],
    //     mode: "lines+markers",
    //     name: this.droppedCharts[index],
    //   };

    //   const layout = { title: this.droppedCharts[index] };
    //   Plotly.newPlot(container, [trace], layout);
    // },
    async fetchChartsData(chart, index) {
      if (typeof this.loading !== 'object') {
        this.loading = {};
      }
      this.loading[index] = true;
      const response = await api.get(`public/api/charts/data/${chart.ID}`);

      if (
        response &&
        response.data &&
        (response.data.statusCode === 200 || response.data.statusCode === 201)
      ) {
        const rows = response.data.data.samples.rows;
        if (rows) {
          this.tableData[index] = rows.map((row) => {
            Object.keys(row).forEach((key) => {
              if (key + "_decimal" in row && row[key + "_decimal"] !== null) {
                // Convert to number first, then format to prevent string comparison issues
                const numValue = parseFloat(row[key]);
                if (!isNaN(numValue)) {
                  row[key] = numValue; // Keep as number for proper sorting and comparison
                }
              }
            });
            // this.xAxisCaption[index] = row.caption
            // this.yAxisCaption[index] = row.caption
            return row;
          });
          const xAxisColumn = chart.XAxisColumn;
          const capitalizedXAxisColumn = xAxisColumn;
          var xColumnDisplayName = await getDisplayNameDashboard(
            chart.TableType,
            capitalizedXAxisColumn
          );
          this.updatedXColumnDisplayName[index] =
            xColumnDisplayName.displayName;

          const yAxisColumns = chart.YAxisColumn
            ? chart.YAxisColumn.split(",")
            : [];
          if (chart.GroupColumn && chart.YAxisColumn) {
            yAxisColumns.pop();
          }

          const capitalizedYAxisColumns = yAxisColumns;

          var yColumnDisplayNames = await Promise.all(
            capitalizedYAxisColumns.map((column) =>
              getDisplayNameDashboard(chart.TableType, column)
            )
          );

          this.updatedYColumnDisplayName[index] = yColumnDisplayNames
            .map((item) => item.displayName)
            .join(", ");
            
          // Get Group column display name
          if (chart.GroupColumn) {
            const groupColumn = chart.GroupColumn;
            const capitalizedGroupColumn = groupColumn.charAt(0) + groupColumn.slice(1);
            const groupColumnDisplayName = await getDisplayNameDashboard(chart.TableType, capitalizedGroupColumn);
            this.updatedGroupColumnDisplayName[index] = groupColumnDisplayName.displayName;
          } else {
            this.updatedGroupColumnDisplayName[index] = "";
          }
            
            if (typeof this.loading !== 'object') {
        this.loading = {};
      }
      this.loading[index] = false;
          this.renderChart(chart, index, "chart_");
        }
      }
    },
    renderChart(chart, index, refPrefix) {
      if (!chart) {
        return;
      }

      this.$nextTick(() => {
        const chartRef = this.$refs[refPrefix + index];
        if (!chartRef) {
          return;
        }

        const chartDiv = Array.isArray(chartRef) ? chartRef[0] : chartRef;
        if (!chartDiv) return;

        // Check if we have valid data to plot
        if (!this.tableData[index] || this.tableData[index].length === 0) {
          return;
        }

        const traces = this.generateTraces(chart, index);
        const layout = this.generateLayout(chart, index);
        const config = this.generateConfig(chart, index);

        // Validate that traces were generated
        if (!traces || traces.length === 0) {
          return;
        }

        if(chart.ChartType === "Scatter Plot" || chart.ChartType === "Line Plot") {
          layout.xaxis.type = chart?.XAxisScale || "linear";
          layout.yaxis.type = chart?.YAxisScale || "linear";
        } else if(chart.ChartType === "3D Scatter") {
          layout.scene.xaxis.type = chart?.XAxisScale || "linear";
          layout.scene.yaxis.type = chart?.YAxisScale || "linear";
        }

        // For categorical data (component names), ensure proper axis configuration
        const xData = this.tableData[index].map(item => item[chart.XAxisColumn]);
        if (xData && xData.length > 0) {
          const isAllStrings = xData.every(value => typeof value === 'string' && value !== null && value !== undefined);
          const isAllNumbers = xData.every(value => typeof value === 'number' && !isNaN(value) && value !== null && value !== undefined);
          
          // Check if this looks like categorical data (component names, etc.)
          if (isAllStrings && xData.length > 0) {
            const uniqueValues = [...new Set(xData)];
            // Use categorical for string data with reasonable number of unique values
            if (uniqueValues.length <= 100) {
              if (chart.ChartType === "3D Scatter") {
                layout.scene.xaxis.type = 'category';
                layout.scene.xaxis.categoryorder = 'trace'; // Use 'trace' to preserve original order from data
              } else {
                layout.xaxis.type = 'category';
                layout.xaxis.categoryorder = 'trace'; // Use 'trace' to preserve original order from data
              }
            }
          }
          // For numeric data, ensure proper numeric axis
          else if (isAllNumbers) {
            if (chart.ChartType === "3D Scatter") {
              layout.scene.xaxis.type = 'linear';
            } else {
              layout.xaxis.type = 'linear';
            }
          }
          // For mixed data or edge cases, let Plotly auto-detect
          else {
            // Don't set specific type, let Plotly handle it automatically
          }
        }

        // Create the new plot
        Plotly.newPlot(chartDiv, traces, layout, config)
          .then(() => {
            // Plot created successfully
          })
          .catch((error) => {
            console.error('Error creating plot:', error);
          });
      });
    },
    renderModalChart(chart, index) {
      if (!chart) {
        console.warn('Chart is undefined for modal render at index:', index);
        return;
      }

      this.$nextTick(() => {
        const chartRef = this.$refs['modal_chart_' + index];
        if (!chartRef) {
          return;
        }

        const chartDiv = Array.isArray(chartRef) ? chartRef[0] : chartRef;
        if (!chartDiv) {
          return;
        }

        // Check if we have valid data to plot
        if (!this.tableData[index] || this.tableData[index].length === 0) {
          return;
        }

        // Use dynamic height calculation for modal
        const modalHeight = this.calculateModalChartHeight();
        const modalWidth = '100%';

        const traces = this.generateTraces(chart, index);
        const layout = this.generateLayout(chart, index);
        const config = {
          responsive: true,
          displaylogo: false,
          displayModeBar: true,
          modeBarButtonsToRemove: ['lasso2d', 'select2d', 'pan2d', "resetscale", "zoom", "toImage"],
          modeBarButtonsToAdd: [
            {
              name: "Download plot as a png",
              icon: {
                svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${this.camIcon}" width="24" height="24"/>
                  </svg>
                `,
              },
              click: this.downloadPNG.bind(this, chart, index),
            },
            {
              name: "Download CSV",
              icon: {
                svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${this.downloadIcon}" width="24" height="24"/>
                  </svg>
                `,
              },
              click: this.downloadCSV.bind(this, chart, index),
            },
          ],
        };

        // Validate that traces were generated
        if (!traces || traces.length === 0) {
          return;
        }

        this.$nextTick(() => {
          if (chart?.ChartType === "Scatter Plot" || chart?.ChartType === "Line Plot") {
            // Use the same scale logic as main plot - don't override tick settings
            layout.xaxis.type = this.xAxisScaleModal === 'log' ? 'log' : 'auto';
            layout.yaxis.type = this.yAxisScaleModal === 'log' ? 'log' : 'auto';
            
            // For non-log scales, ensure we use the same tick configuration as main plot
            if (this.xAxisScaleModal !== 'log') {
              // Don't override tickmode, nticks, tickformat - let the main layout handle it
              layout.xaxis.autorange = true;
              layout.xaxis.rangemode = 'normal';
            }
            if (this.yAxisScaleModal !== 'log') {
              // Don't override tickmode, nticks, tickformat - let the main layout handle it
              layout.yaxis.autorange = true;
              layout.yaxis.rangemode = 'normal';
            }
          } else if (chart?.ChartType === "3D Scatter") {
            // Use the same scale logic as main plot for 3D scatter plots
            layout.scene.xaxis.type = this.xAxisScaleModal === 'log' ? 'log' : 'auto';
            layout.scene.yaxis.type = this.yAxisScaleModal === 'log' ? 'log' : 'auto';
            
            // For non-log scales, ensure we use the same tick configuration as main plot
            if (this.xAxisScaleModal !== 'log') {
              layout.scene.xaxis.autorange = true;
              layout.scene.xaxis.rangemode = 'normal';
            }
            if (this.yAxisScaleModal !== 'log') {
              layout.scene.yaxis.autorange = true;
              layout.scene.yaxis.rangemode = 'normal';
            }
          }

          // Optimize x-axis for modal view - show proper range instead of individual values
          if (layout.xaxis && this.tableData[index] && this.tableData[index].length > 0) {
            // For numerical data, use proper tick configuration
            layout.xaxis.tickmode = 'linear';
            layout.xaxis.nticks = 8; // Limit to 8 ticks for better readability
            layout.xaxis.tickangle = -45; // Rotate labels for better fit
            layout.xaxis.type = this.xAxisScaleModal === 'log' ? 'log' : 'linear';
            
            // Set proper tick format for numerical data
            if (this.xAxisScaleModal !== 'log') {
              // Use formatted tick format for large numbers
              layout.xaxis.tickformat = this.getFormattedTickFormat(chart, index, 'x');
              layout.xaxis.dtick = undefined; // Let Plotly auto-calculate tick intervals
            }
            
            // Force consistent x-axis behavior regardless of legend presence
            layout.xaxis.fixedrange = false; // Allow zooming but control initial display
            layout.xaxis.constrain = 'domain'; // Constrain to plot domain
            
            // Ensure consistent tick spacing regardless of available space
            const dataLength = this.tableData[index].length;
            if (dataLength > 0) {
              // Calculate tick interval based on data range
              const xValues = this.tableData[index].map(row => {
                const xKey = chart?.XAxisColumn;
                return parseFloat(row[xKey]) || 0;
              }).filter(val => !isNaN(val));
              
              if (xValues.length > 0) {
                const minVal = Math.min(...xValues);
                const maxVal = Math.max(...xValues);
                const range = maxVal - minVal;
                const tickInterval = range / 7; // 8 ticks = 7 intervals
                layout.xaxis.dtick = Math.max(tickInterval, 1); // Ensure minimum tick interval
              }
            }
          }

          // For categorical data (component names), ensure proper axis configuration
          const xData = this.tableData[index].map(item => item[chart.XAxisColumn]);
          if (xData && xData.length > 0) {
            const isAllStrings = xData.every(value => typeof value === 'string' && value !== null && value !== undefined);
            const isAllNumbers = xData.every(value => typeof value === 'number' && !isNaN(value) && value !== null && value !== undefined);
            
            // Check if this looks like categorical data (component names, etc.)
            if (isAllStrings && xData.length > 0) {
              const uniqueValues = [...new Set(xData)];
              // Use categorical for string data with reasonable number of unique values
              if (uniqueValues.length <= 100) {
                // Only set category type if not already set by main layout
                if (chart.ChartType === "3D Scatter") {
                  if (!layout.scene.xaxis.type || layout.scene.xaxis.type === 'auto') {
                    layout.scene.xaxis.type = 'category';
                    layout.scene.xaxis.categoryorder = 'trace'; // Use 'trace' to preserve original order from data
                  }
                } else {
                  if (!layout.xaxis.type || layout.xaxis.type === 'auto') {
                    layout.xaxis.type = 'category';
                    layout.xaxis.categoryorder = 'trace'; // Use 'trace' to preserve original order from data
                  }
                }
              }
            }
            // For numeric data, don't override if already set by main layout
            else if (isAllNumbers) {
              // Only set type if not already set by main layout
              if (chart.ChartType === "3D Scatter") {
                if (!layout.scene.xaxis.type || layout.scene.xaxis.type === 'auto') {
                  layout.scene.xaxis.type = this.xAxisScaleModal === 'log' ? 'log' : 'auto';
                }
                // Don't override tick settings - let the main layout handle it
                layout.scene.xaxis.autorange = true;
                layout.scene.xaxis.rangemode = 'normal';
              } else {
                if (!layout.xaxis.type || layout.xaxis.type === 'auto') {
                  layout.xaxis.type = this.xAxisScaleModal === 'log' ? 'log' : 'auto';
                }
                // Don't override tick settings - let the main layout handle it
                layout.xaxis.autorange = true;
                layout.xaxis.rangemode = 'normal';
              }
            }
            // For mixed data or edge cases, let Plotly auto-detect
            else {
              // Don't set specific type, let Plotly handle it automatically
            }
          }

          // Update layout with calculated dimensions
          layout.height = modalHeight;

          // Create the new plot
          Plotly.newPlot(chartDiv, traces, layout, config)
            .then(() => {
              // Plot created successfully
            })
            .catch((error) => {
              console.error('Error creating modal plot:', error);
            });
        });
      });
    },
    generateTraces(chart, index) {
      if (!chart) {
        return [];
      }

      if (!chart.ChartType) {
        return [];
      }

      // Validate data availability
      if (!this.tableData[index] || this.tableData[index].length === 0) {
        return [];
      }

      const traceType = this.getTraceType(chart);
      const traceMode = this.getTraceMode(chart, index);
      const scatterMarkerSizes = 8;
      const yColumns = chart.YAxisColumn ? chart.YAxisColumn.split(",") : [];
      this.selectedYAxisKeys[index] = yColumns;

      // grouped‐by‐color charts
      if (chart.GroupColumn && chart.YAxisColumn) {
        yColumns.pop();
        this.selectedColorGroupKeys[index] = chart.GroupColumn;
        this.selectedXAxisKeys[index] = chart.XAxisColumn;
        this.selectedZAxisKeys[index] = chart.ZAxisColumn;
        this.xBins[index] = chart.NumXBins;
        this.yBins[index] = chart.NumYBins;

        const colorGroupData = this.tableData[index].map(item => item[chart.GroupColumn]);
        const uniqueValues = [...new Set(colorGroupData.filter(item => item !== undefined && item !== null))];

        const groupedYAxisData = {};
        const groupedXAxisData = {};
        const groupedZAxisData = {};

        uniqueValues.forEach(value => {
          groupedYAxisData[value] = [];
          groupedXAxisData[value] = [];
          groupedZAxisData[value] = [];
        });

        this.tableData[index].forEach(row => {
          const colorGroupValue = row[this.selectedColorGroupKeys[index]];

          if (uniqueValues.includes(colorGroupValue)) {
            const yAxisRowData = this.selectedYAxisKeys[index].map(key => row[key]);
            groupedYAxisData[colorGroupValue].push(yAxisRowData);

            const xAxisRowData = row[this.selectedXAxisKeys[index]];
            groupedXAxisData[colorGroupValue].push(xAxisRowData);

            const zAxisRowData = row[this.selectedZAxisKeys[index]];
            groupedZAxisData[colorGroupValue].push(zAxisRowData);
          }
        });

        // Generate traces by grouping primarily by _id, then by legend for color assignment
        // This approach ensures each unique _id gets its own trace regardless of legend
        const idGroups = {};
        
        // Group tableData by _id first (primary grouping)
        this.tableData[index].forEach((row) => {
          const dataId = row.uniqueID;
          const legend = row[chart.GroupColumn];
          
          if (!idGroups[dataId]) {
            idGroups[dataId] = {
              data: [],
              legend: legend
            };
          }
          
          // Use the actual column names from the chart configuration
          const xVal = row[chart.XAxisColumn];
          const yVal = yColumns.length > 0 ? row[yColumns[0]] : null;
          const zVal = chart.ZAxisColumn ? row[chart.ZAxisColumn] : null;
          
          if (xVal !== null && xVal !== undefined && xVal !== '' && 
              yVal !== null && yVal !== undefined && yVal !== '' && 
              !isNaN(yVal)) { // Only check yVal for NaN since xVal can be string
            
            // Convert xVal to number if it's a numeric string
            let processedXVal = xVal;
            if (typeof xVal === 'string' && !isNaN(parseFloat(xVal))) {
              processedXVal = parseFloat(xVal);
            }
            
            idGroups[dataId].data.push({ x: processedXVal, y: yVal, z: zVal, originalRow: row });
          }
        });
        
       
        
        // Create traces array to store all traces
        const traces = [];
        let colorIndex = 0;
        const shownLegends = new Set(); // Track which legends we've already shown
        
        // Create a color mapping for each legend type
        const legendColorMap = {};
        
        // Create a trace for each unique _id
        Object.keys(idGroups).forEach((idKey, index) => {
          const idGroup = idGroups[idKey];
          const validData = idGroup.data;
          const legend = idGroup.legend;
          const markerSize = (chart.ChartType === "Scatter Plot") ? scatterMarkerSizes : (this.markerSizes && this.markerSizes.length > 0 ? this.markerSizes : [10]);
          
          if (validData.length === 0) {
            return;
          }

          // Assign color based on legend type, not individual traces
          if (!legendColorMap[legend]) {
            legendColorMap[legend] = this.getColorForIndex(Object.keys(legendColorMap).length % 6);
          }
          const traceColor = legendColorMap[legend];

          // Track which legend types we've already shown
          const isFirstOfType = !shownLegends.has(legend);
          if (isFirstOfType) {
            shownLegends.add(legend);
          }

          // Sort data by x-axis values to ensure proper propagation pattern
          // For numeric data: sort x-axis ascending (lower values first) for proper propagation
          // For string data: preserve original order
          const isXNumeric = validData.every(item => typeof item.x === 'number' && !isNaN(item.x));
          let sortedData;
          
          if (isXNumeric) {
            // Sort by x-axis ascending for proper propagation pattern (lower values first)
            sortedData = validData.sort((a, b) => a.x - b.x);
          } else {
            // For string data, preserve original order
            sortedData = validData;
          }
          
          const validXData = sortedData.map(item => item.x);
          const validYData = sortedData.map(item => item.y);
          const validZData = sortedData.map(item => item.z);

          const processedYData = validYData.map(item => Array.isArray(item) ? item[0] : item);

          const trace = {
            x: validXData,
            y: processedYData,
            z: validZData,
            type: traceType,
            mode: traceMode,
            marker: {
              size: markerSize,
              color: traceColor // Use the same color for all traces of the same legend type
            },
            name: legend, // Use legend type as name
            legendgroup: legend, // Group by legend type
            showlegend: isFirstOfType, // Show only one legend entry per type
            // Add connectgaps: false to prevent connecting points across gaps
            connectgaps: false,
            customdata: validXData.map((xValue, dataIndex) => {
              // Use caption from the original row data like DynamicChart
              const item = sortedData[dataIndex];
              return item && item.originalRow && item.originalRow.caption ? item.originalRow.caption : 'N/A';
            }),
            hovertemplate: `
%{x}  %{y}  %{customdata}
<extra></extra>
`,
          };

          if (chart.ChartType === "Bubble" || chart.ChartType === "3D Scatter") {
            const markerSizes = this.markerSizes && this.markerSizes.length > 0 ? this.markerSizes : [10];
            const maxMarkerSize = Math.max(...markerSizes);
            trace.marker = {
              ...trace.marker,
              sizemode: 'area',
              sizeref: 2.0 * maxMarkerSize / (80 * 2), // Adjusted size reference for better fitting
              sizemin: 2,
            };
          }

            if (["2D Histogram"].includes(chart.ChartType)) {
              trace.autobinx = false;
              trace.autobiny = false;
              trace.xbins = { 
                size: this.calculateBinSize(validXData, this.xBins[index]),
                start: Math.min(...validXData),
                end: Math.max(...validXData)
              };
              trace.ybins = { 
                size: this.calculateBinSize(processedYData, this.yBins[index]),
                start: Math.min(...processedYData),
                end: Math.max(...processedYData)
              };
            }

            traces.push(trace);
            
            // Mark this legend as shown
            shownLegends.add(legend);
            colorIndex++;
          });

        return traces.filter(trace => trace !== null);
      } else {
        const xData = this.tableData[index].map(item => item[chart.XAxisColumn]);
        this.xBins[index] = chart.NumXBins;

        // Check if any of the data arrays are invalid
        const isInvalidData = (data) => !data || data.every(value => value === null || value === undefined);

        if (isInvalidData(xData)) {
          return [];
        }

        if (chart.ChartType === "Histogram") {
          // Filter out invalid data - allow both strings and numbers
          const validXData = xData.filter(value => 
            value !== null && 
            value !== undefined && 
            value !== ''
          );
          
          if (validXData.length === 0) {
            return [];
          }
          
          // Check if data is numeric for sorting and binning
          const isNumericData = validXData.every(value => typeof value === 'number' && !isNaN(value));
          
          let sortedData, minVal, maxVal;
          
          if (isNumericData) {
            // Sort numeric data for consistent plotting
            sortedData = validXData.sort((a, b) => a - b);
            minVal = Math.min(...sortedData);
            maxVal = Math.max(...sortedData);
          } else {
            // For string data, don't sort and use categorical bins
            sortedData = validXData;
            minVal = 0;
            maxVal = sortedData.length;
          }
          
          // Check if histogram has GroupColumn for legend grouping
          if (chart.GroupColumn) {
            // Check if the GroupColumn actually exists in the data
            const hasGroupColumn = this.tableData[index][0] && chart.GroupColumn in this.tableData[index][0];
            
            if (hasGroupColumn) {
              // Group data by GroupColumn for legend
              const groupedData = {};
              this.tableData[index].forEach(row => {
                const groupValue = row[chart.GroupColumn];
                const xValue = row[chart.XAxisColumn];
                
                if (groupValue !== null && groupValue !== undefined && 
                    xValue !== null && xValue !== undefined && xValue !== '') {
                  if (!groupedData[groupValue]) {
                    groupedData[groupValue] = [];
                  }
                  groupedData[groupValue].push(xValue);
                }
              });

              // Only create grouped traces if we have valid groups
              if (Object.keys(groupedData).length > 0) {
                // Calculate unified bin boundaries for ALL groups to ensure consistent binning
                let unifiedXbinsConfig = undefined;
                let isNumericData = false;
                
                // First, collect all data from all groups to calculate unified bin boundaries
                const allXData = [];
                for (const key of Object.keys(groupedData)) {
                  const xData = groupedData[key];
                  const validXData = xData.filter(value => 
                    value !== null && 
                    value !== undefined && 
                    value !== ''
                  );
                  allXData.push(...validXData);
                }
                
                if (allXData.length > 0) {
                  // Check if all data is numeric
                  isNumericData = allXData.every(value => {
                    if (typeof value === 'number') {
                      return !isNaN(value);
                    }
                    if (typeof value === 'string') {
                      const num = parseFloat(value);
                      return !isNaN(num) && isFinite(num);
                    }
                    return false;
                  });
                  
                  if (isNumericData) {
                    // Convert string numbers to actual numbers
                    const numericData = allXData.map(value => {
                      if (typeof value === 'string') {
                        return parseFloat(value);
                      }
                      return value;
                    });
                    
                    const minVal = Math.min(...numericData);
                    const maxVal = Math.max(...numericData);
                    const range = maxVal - minVal;
                    
                    if (range > 0) {
                      // Ensure minimum value starts from 0 for positive data
                      const adjustedMinVal = Math.max(0, minVal);
                      const adjustedRange = maxVal - adjustedMinVal;
                      
                      // Add small padding to ensure all data points are included
                      const padding = adjustedRange * 0.001; // 0.1% padding
                      const binSize = (adjustedRange + 2 * padding) / this.xBins[index];
                      
                      unifiedXbinsConfig = {
                        start: Math.max(0, adjustedMinVal - padding), // Ensure start is never negative
                        end: maxVal + padding,
                        size: binSize
                      };
                    }
                  }
                }

                // Create traces for each group using unified bin boundaries
                const traces = [];
                const uniqueGroups = Object.keys(groupedData).sort(); // Sort for consistent color assignment
                let colorIndex = 0;

                uniqueGroups.forEach(groupValue => {
                  const groupData = groupedData[groupValue];
                  if (groupData.length === 0) return;

                  // Sort group data if numeric
                  const isGroupNumeric = groupData.every(value => typeof value === 'number' && !isNaN(value));
                  const sortedGroupData = isGroupNumeric ? groupData.sort((a, b) => a - b) : groupData;

                  const trace = {
                    x: sortedGroupData,
                    type: traceType,
                    autobinx: false,
                    nbinsx: this.xBins[index],
                    xbins: unifiedXbinsConfig, // Use unified bin boundaries for all groups
                    marker: {
                      color: this.getColorForIndex(colorIndex % 6),
                      line: {
                        color: "rgba(0, 0, 0, 1)",
                        width: 1
                      }
                    },
                    name: groupValue,
                    showlegend: true,
                    customdata: sortedGroupData.map((value, dataIndex) => {
                      // For histograms with legends, use the legend group name as caption
                      return groupValue; // Return the legend group name (e.g., "FD", "ML", "AI", "AGI")
                    }),
                    hovertemplate: `
  <b>${groupValue}</b><br>
  Range: %{x}<br>
  Count: %{y}
  <extra></extra>
`,
                  };

                  traces.push(trace);
                  colorIndex++;
                });

                return traces;
              }
            }
          }
          
          // Single histogram without grouping (or when grouping fails)
          const barColor = "rgba(0, 100, 250, 0.6)";
          const borderColor = "rgba(0, 0, 0, 1)";
          const borderWidth = 1;

          const trace = {
            x: sortedData,
            type: traceType,
            autobinx: false,
            nbinsx: this.xBins[index], // Use exact number of bins
            xbins: isNumericData ? {
              start: minVal,
              end: maxVal,
              size: (maxVal - minVal) / this.xBins[index]
            } : undefined, // Let Plotly handle categorical binning
            marker: {
              color: barColor,
              line: {
                color: borderColor,
                width: borderWidth
              }
            },
            showlegend: false, // No legend for single histogram
            // Remove customdata for simple histograms to avoid caption display
            hovertemplate: `
  Range: %{x}<br>
  Count: %{y}
  <extra></extra>
`,
          };

          return [trace];
        }

        // Handle case when no legend is selected but we still want to group by _id
        if (chart.ChartType === "Line Plot" || chart.ChartType === "Scatter Plot") {
          // Group by _id to prevent spaghetti lines even without legend
          const idGroups = {};
          
          this.tableData[index].forEach((row) => {
            const dataId = row.uniqueID;
            
            if (!idGroups[dataId]) {
              idGroups[dataId] = [];
            }
            
            // Use the actual column names from the chart configuration
            const xVal = row[chart.XAxisColumn];
            const yVal = yColumns.length > 0 ? row[yColumns[0]] : null;
            const zVal = chart.ZAxisColumn ? row[chart.ZAxisColumn] : null;
            
            if (xVal !== null && xVal !== undefined && xVal !== '' && 
                yVal !== null && yVal !== undefined && yVal !== '' && 
                !isNaN(yVal)) {
              
              let processedXVal = xVal;
              if (typeof xVal === 'string' && !isNaN(parseFloat(xVal))) {
                processedXVal = parseFloat(xVal);
              }
              
              idGroups[dataId].push({ x: processedXVal, y: yVal, z: zVal, originalRow: row });
            }
          });
          
          // Create traces for each unique _id with same color
          const traces = [];
          const singleColor = "rgba(0, 100, 250, 0.8)"; // Same blue color for all
          
          Object.keys(idGroups).forEach((idKey) => {
            const validData = idGroups[idKey];
            
            if (validData.length === 0) {
              return;
            }

            // Sort data by x-axis values
            const sortedData = validData.sort((a, b) => a.x - b.x);
            const validXData = sortedData.map(item => item.x);
            const validYData = sortedData.map(item => item.y);
            const validZData = sortedData.map(item => item.z);

            const processedYData = validYData.map(item => Array.isArray(item) ? item[0] : item);

            const trace = {
              x: validXData,
              y: processedYData,
              z: validZData,
              type: traceType,
              mode: traceMode,
              marker: {
                size: (chart.ChartType === "Scatter Plot") ? scatterMarkerSizes : (this.markerSizes && this.markerSizes.length > 0 ? this.markerSizes : [10]),
                color: singleColor
              },
              name: `Data Series ${Object.keys(idGroups).indexOf(idKey) + 1}`, // Generic name
              showlegend: false, // No legend since it's not really a legend
              connectgaps: false,
              customdata: validXData.map((xValue, dataIndex) => {
                // Use caption from the original row data like DynamicChart
                const item = sortedData[dataIndex];
                return item && item.originalRow && item.originalRow.caption ? item.originalRow.caption : 'N/A';
              }),
              hovertemplate: `
%{x}  %{y}  %{customdata}
<extra></extra>
`,
            };

            traces.push(trace);
          });

          return traces.filter(trace => trace !== null);
        }

        // all other chart types remain unchanged
        const yData = yColumns.map(col => this.tableData[index].map(item => item[col]));
        this.yBins[index] = chart.NumYBins;
        const zData = this.tableData[index].map(item => item[chart.ZAxisColumn]);
        this.markerSizes = [...zData];

        const markerSize = (chart.ChartType === "Scatter Plot")
          ? scatterMarkerSizes
          : (this.markerSizes && this.markerSizes.length > 0 ? this.markerSizes : [10]);

        return yData.map((y, i) => {
          // Check if Y data is invalid
          if (isInvalidData(y)) {
            return null;
          }

          // Filter out invalid data points
          const validData = xData.map((xVal, j) => {
            const yVal = y[j];
            if (xVal !== null && xVal !== undefined && xVal !== '' && 
                yVal !== null && yVal !== undefined && yVal !== '' && 
                !isNaN(yVal)) {
              return { x: xVal, y: yVal, index: j };
            }
            return null;
          }).filter(item => item !== null);

          if (validData.length === 0) {
            return null;
          }

          // Sort data by x-axis values to prevent restarting issues
          // For string data, preserve original order; for numeric data, sort numerically
          const isXNumeric = validData.every(item => typeof item.x === 'number' && !isNaN(item.x));
          const sortedData = isXNumeric 
            ? validData.sort((a, b) => a.x - b.x)
            : validData; // Keep original order for string data

          const trace = {
            x: sortedData.map(item => item.x),
            y: sortedData.map(item => item.y),
            z: zData,
            type: traceType,
            mode: traceMode,
            name: this.updatedYColumnDisplayName[index] ? 
              this.updatedYColumnDisplayName[index].split(", ")[i] || yColumns[i] : 
              yColumns[i],
            marker: { 
              size: markerSize,
              // Add blue color for all plots without legend (except histogram)
              ...(chart.ChartType !== 'Histogram' && !chart.GroupColumn ? {
                color: 'rgba(0, 100, 250, 0.8)' // Blue color for all plots without legend
              } : {})
            },
          };

          if (chart.ChartType === "Bubble" || chart.ChartType === "3D Scatter") {
            const markerSizes = this.markerSizes && this.markerSizes.length > 0 ? this.markerSizes : [10];
            const maxMarkerSize = Math.max(...markerSizes);
            trace.marker = {
              ...trace.marker,
              sizemode: 'area',
              sizeref: 2.0 * maxMarkerSize / (80 * 2), // Adjusted size reference for better fitting
              sizemin: 2,
            };
          }

          if (chart.ChartType === "2D Histogram") {
            trace.colorscale = [
              [0.0, 'rgba(247,251,255,255)'],
              [0.25, 'rgba(193,217,237,255)'],
              [0.5, 'rgba(97,167,210,255)'],
              [0.75, 'rgba(24,101,172,255)'],
              [1.0, 'rgba(8,48,108,255)']
            ];
            trace.colorbar = {
              title: {
                text: 'Number of Samples', // Title for the color bar
                side: 'right',
              }
            };
          }

          if (["2D Histogram"].includes(chart.ChartType)) {
            trace.autobinx = false;
            trace.autobiny = false;
            trace.xbins = { 
              size: this.calculateBinSize(sortedData.map(item => item.x), this.xBins[index]),
              start: Math.min(...sortedData.map(item => item.x)),
              end: Math.max(...sortedData.map(item => item.x))
            };
            trace.ybins = { 
              size: this.calculateBinSize(sortedData.map(item => item.y), this.yBins[index]),
              start: Math.min(...sortedData.map(item => item.y)),
              end: Math.max(...sortedData.map(item => item.y))
            };
          }

          // Add customdata for non-legend charts
          trace.customdata = sortedData.map((item, dataIndex) => {
            // For non-legend charts, use original index from sortedData to get correct caption
            const originalIndex = item.index;
            if (this.tableData[index] && this.tableData[index][originalIndex] && this.tableData[index][originalIndex].caption) {
              return this.tableData[index][originalIndex].caption;
            }
            return 'N/A';
          });
          trace.hovertemplate = `
%{x}  %{y}  %{customdata}
<extra></extra>
`;

          return trace;
        }).filter(trace => trace !== null);
      }
    },

    calculateBinSize(data, bins) {
      // Handle edge cases
      if (!data || data.length === 0 || !bins || bins < 1) {
        return 1;
      }
      
      // Filter out null, undefined, and NaN values
      const validData = data.filter(value => 
        value !== null && 
        value !== undefined && 
        value !== '' && 
        !isNaN(value)
      );
      
      if (validData.length === 0) {
        return 1;
      }
      
      // For numeric data, use proper bin calculation
      const numericData = validData.filter(value => typeof value === 'number');
      if (numericData.length > 0) {
        const minValue = Math.min(...numericData);
        const maxValue = Math.max(...numericData);
        const range = maxValue - minValue;
        
        // Prevent division by zero
        if (range === 0) {
          return 1;
        }
        
        // Use the exact number of bins requested
        const binSize = range / bins;
        
        // Ensure minimum bin size to prevent too many bins
        const minBinSize = range / 100; // Maximum 100 bins
        const finalBinSize = Math.max(binSize, minBinSize);
        
        return finalBinSize;
      }
      
      // For non-numeric data (categorical), use unique values
      const uniqueValues = [...new Set(validData)];
      const uniqueCount = uniqueValues.length;
      
      // For categorical data, use the requested number of bins
      const optimalBins = Math.min(bins, uniqueCount);
      
      return Math.max(uniqueCount / optimalBins, 1);
    },

    generateLayout(chart, index) {
      if (!chart) {
        return {};
      }

      // Validate required properties like ChartType
      if (!chart.ChartType) {
        return {};
      }

      const yColumns = chart.YAxisColumn ? chart.YAxisColumn.split(",") : [];
      if (chart.GroupColumn && chart.YAxisColumn) {
        yColumns.pop(); // Remove the last Y-axis column if GroupColumn is present
      }

      const baseLayout = {
        margin: {
          l: 55,
          r: 0,
          b: 100
        },
        ...(chart.ChartType === "Histogram" ? {
          plot_bgcolor: this.isDarkMode ? 'transparent' : '#e5ecf6',  
          paper_bgcolor: this.isDarkMode ? 'transparent' : '#ffffff',
        } : {}),
        legend: {
          title: {
            text: this.selectedColorGroupKeys[index] ? (this.updatedGroupColumnDisplayName[index] || this.selectedColorGroupKeys[index]) : ''
          },
          // Show legend for histograms with GroupColumn or when color group is selected
          visible: (this.selectedColorGroupKeys[index] && this.selectedColorGroupKeys[index].trim() !== '') || 
                   (chart.ChartType === "Histogram" && chart.GroupColumn) ? true : false
        },
      };

      const layout = {
        ...(chart.ChartType === "3D Scatter" ? {
          scene: {
            xaxis: {
              title: { 
                text: this.formatAxisTitle(
                  this.updatedXColumnDisplayName[index] || chart.XAxisColumn,
                  this.getUOMForProperty(chart.XAxisColumn, index)
                )
              },
              tickangle: -45,
              tickfont: { size: 10 },
              automargin: true,
              autorange: true,
              type: 'auto',
              tickmode: 'auto',
              nticks: undefined,
              tickformat: this.getFormattedTickFormat(chart, index, 'x'),
              showgrid: true,
              gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
              gridwidth: 0.5,
            },
            yaxis: {
              title: {
                text: this.formatAxisTitle(
                  this.updatedYColumnDisplayName[index]?.replace(/, /g, "<br>") || yColumns.join(", ")?.replace(/, /g, "<br>"),
                  this.getUOMForProperty(yColumns[0], index)
                ),
                standoff: 15,
              },
              tickfont: { size: 10 },
              automargin: true,
              autorange: true,
              type: 'auto',
              tickmode: 'auto',
              nticks: undefined,
              tickformat: this.getFormattedTickFormat(chart, index, 'y'),
              showgrid: true,
              gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
              gridwidth: 0.5,
            },
            zaxis: {
              title: {
                text: this.formatAxisTitle(
                  chart.ZAxisColumn || "Z",
                  this.getUOMForProperty(chart.ZAxisColumn, index)
                ),
                standoff: 15,
              },
              tickfont: { size: 10 },
              automargin: true,
              autorange: true,
              type: 'auto',
              tickmode: 'auto',
              nticks: undefined,
              tickformat: this.getFormattedTickFormat(chart, index, 'z'),
              showgrid: true,
              gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
              gridwidth: 0.5,
            },
            camera: {
              eye: { x: 1.5, y: 1.5, z: 1.5 },
              center: { x: 0, y: 0, z: 0 },
              up: { x: 0, y: 0, z: 1 }
            },
            aspectmode: 'auto',
            aspectratio: { x: 1, y: 1, z: 1 }
          }
        } : {
          xaxis: {
            title: { 
              text: this.formatAxisTitle(
                this.updatedXColumnDisplayName[index] || chart.XAxisColumn,
                this.getUOMForProperty(chart.XAxisColumn, index)
              )
            },
            tickangle: -45,
            tickfont: { size: 10 },
            automargin: true,
            autorange: true,
            type: 'auto',
            tickmode: 'auto',
            nticks: undefined,
            tickformat: this.getFormattedTickFormat(chart, index, 'x'),
            showgrid: true,
            gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
            gridwidth: 0.5,
          },
          yaxis: { 
            title: {
              text: chart.ChartType === "Histogram"
                ? "No. of Samples"
                : this.formatAxisTitle(
                    this.updatedYColumnDisplayName[index]?.replace(/, /g, "<br>") || yColumns.join(", ")?.replace(/, /g, "<br>"),
                    this.getUOMForProperty(yColumns[0], index)
                  ),
              standoff: 15,
            },
            tickfont: { size: 10 },
            automargin: true,
            autorange: true,
            type: 'auto',
            tickmode: 'auto',
            nticks: undefined,
            tickformat: this.getFormattedTickFormat(chart, index, 'y'),
            showgrid: true,
            gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
            gridwidth: 0.5,
          },
        }),
        ...baseLayout,
      };

      // For categorical data (like component names), ensure proper axis configuration
      if (this.tableData[index] && this.tableData[index].length > 0) {
        const xData = this.tableData[index].map(item => item[chart.XAxisColumn]);
        if (xData && xData.length > 0) {
          const isAllStrings = xData.every(value => typeof value === 'string' && value !== null && value !== undefined);
          const isAllNumbers = xData.every(value => typeof value === 'number' && !isNaN(value) && value !== null && value !== undefined);
          
          // Check if this looks like categorical data (component names, etc.)
          if (isAllStrings && xData.length > 0) {
            const uniqueValues = [...new Set(xData)];
            // Use categorical for string data with reasonable number of unique values
            if (uniqueValues.length <= 100) {
              if (chart.ChartType === "3D Scatter") {
                layout.scene.xaxis.type = 'category';
                layout.scene.xaxis.categoryorder = 'trace'; // Use 'trace' to preserve original order from data
                layout.scene.xaxis.tickmode = 'auto';
                layout.scene.xaxis.nticks = undefined;
                layout.scene.xaxis.autorange = true;
              } else {
                layout.xaxis.type = 'category';
                layout.xaxis.categoryorder = 'trace'; // Use 'trace' to preserve original order from data
                layout.xaxis.tickmode = 'auto';
                layout.xaxis.nticks = undefined;
                layout.xaxis.autorange = true;
              }
            }
          }
          // For numeric data, ensure proper numeric axis and sorting
          else if (isAllNumbers) {
            if (chart.ChartType === "3D Scatter") {
              layout.scene.xaxis.type = chart?.XAxisScale || 'linear';
              // Ensure dynamic scaling is maintained
              layout.scene.xaxis.autorange = true;
              layout.scene.xaxis.tickmode = 'auto';
              layout.scene.xaxis.nticks = undefined;
              layout.scene.xaxis.tickformat = this.getFormattedTickFormat(chart, index, 'x');
            } else {
              layout.xaxis.type = chart?.XAxisScale || 'linear';
              // Ensure dynamic scaling is maintained
              layout.xaxis.autorange = true;
              layout.xaxis.tickmode = 'auto';
              layout.xaxis.nticks = undefined;
              layout.xaxis.tickformat = this.getFormattedTickFormat(chart, index, 'x');
            }
          }
          // For mixed data or edge cases, let Plotly auto-detect
          else {
            // Don't set specific type, let Plotly handle it automatically
            if (chart.ChartType === "3D Scatter") {
              layout.scene.xaxis.autorange = true;
            } else {
              layout.xaxis.autorange = true;
            }
          }
        }
      }

      // Handle histogram-specific axis configuration only for numeric data
      if (chart.ChartType === "Histogram" || chart.ChartType === "2D Histogram") {
        if (this.tableData[index] && this.tableData[index].length > 0) {
          const xData = this.tableData[index].map(item => item[chart.XAxisColumn]);
          if (xData && xData.length > 0) {
            const isAllNumbers = xData.every(value => typeof value === 'number' && !isNaN(value) && value !== null && value !== undefined);
            if (isAllNumbers && !layout.xaxis.type) {
              layout.xaxis.type = chart?.XAxisScale || 'linear';
            }
          }
        }
        if (this.tableData[index] && this.tableData[index].length > 0 && chart.YAxisColumn) {
          const yColumns = chart.YAxisColumn.split(",");
          const yData = yColumns.map(col => this.tableData[index].map(item => item[col])).flat();
          if (yData && yData.length > 0) {
            const isAllNumbers = yData.every(value => typeof value === 'number' && !isNaN(value) && value !== null && value !== undefined);
            if (isAllNumbers && !layout.yaxis.type) {
              layout.yaxis.type = chart?.YAxisScale || 'linear';
            }
          }
        }
      }

      return layout;
    },
    generateConfig(chart, index) {
      const config = {
        responsive: true,
        displaylogo: false,
        displayModeBar: true,
      };

      if (this.isEditing) {
        // For editing mode, hide all buttons except the remove button
        config.modeBarButtonsToRemove = [
          "lasso2d", "select2d", "pan2d", "resetscale", "zoom", "toImage", "toggleSpikelines", 
          "hoverClosestCartesian", "hoverCompareCartesian", "zoomIn", "zoomOut", "autoScale",
          "pan", "select", "lasso", "box", "autoScale2d", "resetScale2d", "hoverClosestGl2d",
          "hoverClosestPie", "toggleHover", "resetViews", "toggleSpikelines", "resetViewMapbox"
        ];
        config.modeBarButtonsToAdd = [
          {
            name: "Remove from Dashboard",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${this.cross}" width="24" height="24"/>
                </svg>
              `,
            },
            click: () => {
              // Call a function to remove the plot from the specified index
              this.removePlotFromIndex(index, chart);
            },
          },
        ];
      } else {
        // For non-editing mode, also hide all buttons except the remove button
        config.modeBarButtonsToRemove = [
          "lasso2d", "select2d", "pan2d", "resetscale", "zoom", "toImage", "toggleSpikelines", 
          "hoverClosestCartesian", "hoverCompareCartesian", "zoomIn", "zoomOut", "autoScale",
          "pan", "select", "lasso", "box", "autoScale2d", "resetScale2d", "hoverClosestGl2d",
          "hoverClosestPie", "toggleHover", "resetViews", "toggleSpikelines", "resetViewMapbox"
        ];
        config.modeBarButtonsToAdd = [
          {
            name: "Remove from Dashboard",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${this.cross}" width="24" height="24"/>
                </svg>
              `,
            },
            click: () => {
              // Emit an event to notify the parent component to close the chart
              this.removePlotFromIndex(index, chart);
            },
          },
        ];
      }

      return config;
    },
    getTraceType(chart) {
      if (!chart || !chart.ChartType) {
        return "scatter"; // Return default instead of null
      }
      switch (chart.ChartType) {
        case "Line Plot": return "scatter";
        case "Bar Chart": return "bar";
        case "Histogram": return "histogram";
        case "Bubble": return "scatter";
        case "3D Scatter": return "scatter3d";
        case "Scatter Plot": return "scatter";
        case "2D Histogram": return "histogram2d";
        case "Heatmap": return "heatmap";
        case "Treemap": return "treemap";
        default: return "scatter";
      }
    },

    getTraceMode(chart, index) {
      // Check if this is a large dataset
      const isLargeDataset = this.tableData[index] && this.tableData[index].length > 1000;
      
      if (chart.ChartType === "Bubble") return "markers";
      if (chart.ChartType === "Scatter Plot") return "markers";
      if (chart.ChartType === "3D Scatter") return "markers";
      if (chart.ChartType === "Line Plot") {
        // Remove markers for line plots to improve performance and cleaner appearance
        return "lines";
      }
      return undefined;
    },
    openModal(chart, index) {
      if (!chart) {
        console.warn('Chart is undefined for index:', index);
        return;
      }
      
      this.xAxisScaleModal = chart.XAxisScale || "linear";
      this.yAxisScaleModal = chart.YAxisScale || "linear";
      if (this.xAxisScaleModal === "log") {
        this.isModalXLog = true;
      }
      else {
        this.isModalXLog = false;
      }
      if (this.yAxisScaleModal === "log") {
        this.isModalYLog = true;
      }
      else {
        this.isModalYLog = false;
      }
      
      this.expandedIndex = index;
      this.isPreviewOpen[index] = true;
      
      this.$nextTick(() => {
        this.resizeChart(index, "modal_chart_");
        // Delay plotModalChart to ensure the modal is fully rendered
        this.$nextTick(() => {
          this.renderModalChart(chart, index);
        });
      });
    },

    closeModal(index) {
      this.isPreviewOpen[index] = false;
    },

    resizeChart(index, refPrefix) {
      this.$nextTick(() => {
        const chartRef = this.$refs[refPrefix + index];
        
        if (!chartRef) {
          console.warn(`Chart reference for ${refPrefix + index} is undefined.`);
          return;
        }

        const chartDiv = Array.isArray(chartRef) ? chartRef[0] : chartRef;
        if (!chartDiv) return;

        Plotly.Plots.resize(chartDiv); // Resize the chart
      });
    },
    resizeAllCharts() {
      this.$nextTick(() => {
        for (let i = 0; i < this.droppedCharts.length; i++) {
          if (!this.droppedCharts[i]) continue; // Skip if chart is null or undefined
          
          const chartRef = this.$refs['chart_' + i];
          if (!chartRef) {
            continue;
          }

          const chartDiv = Array.isArray(chartRef) ? chartRef[0] : chartRef;
          if (!chartDiv) return;

          Plotly.Plots.resize(chartDiv); // Resize the chart
        }
      });
    },

    handleDownloadCSV(index, chart) {
      const chartData = this.tableData[index];
      const chartName = this.droppedCharts[index].Name;
      const csvContent = this.convertToCsv(chartData, chartName);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const fileName = `${chartName}.csv`;

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },

    downloadPNG(chart, index) {
      const chartRef = this.$refs['chart_' + index];
      if (!chartRef) {
        return;
      }

      const chartDiv = Array.isArray(chartRef) ? chartRef[0] : chartRef;
      if (!chartDiv) {
        return;
      }

      // Create a temporary div for the download
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.style.top = '-9999px';
      document.body.appendChild(tempDiv);

      // Get the current traces and create a temporary layout with title
      const traces = this.generateTraces(chart, index);
      const layoutWithTitle = this.generateLayout(chart, index);
      layoutWithTitle.title = {
        text: chart.Name,
        font: {
          size: 16,
          color: '#333'
        },
        x: 0.5,
        y: 0.95
      };

      // Create the temporary plot with title
      Plotly.newPlot(tempDiv, traces, layoutWithTitle, {
        displayModeBar: false,
        responsive: true
      }).then(() => {
        // Download the PNG with title included
        Plotly.downloadImage(tempDiv, {
          format: 'png',
          filename: chart.Name || 'chart',
          height: 600,
          width: 800
        }).then(() => {
          // Clean up the temporary div
          document.body.removeChild(tempDiv);
        });
      });
    },

    getDecimalPrecision(chart, columnName) {
      // Get decimal precision from the first row of table data if available
      if (this.tableData && this.tableData.length > 0) {
        const firstRow = this.tableData[0];
        const decimalKey = `${columnName}_decimal`;
        if (firstRow[decimalKey] !== undefined && firstRow[decimalKey] !== null) {
          const precision = firstRow[decimalKey];
          // For sales data or when decimal precision is 0, return 0 to avoid showing .00
          if (precision === 0) {
            return 0;
          }
          return Math.min(precision, 6); // Cap at 6 decimal places
        }
      }
      return 2; // Default to 2 decimal places
    },

    // Check if axis data should be formatted with k/M/B notation
    shouldFormatAxisData(chart, index, axisType) {
      if (!this.tableData[index] || this.tableData[index].length === 0) {
        return false;
      }

      let columnName;
      if (axisType === 'x') {
        columnName = chart.XAxisColumn;
      } else if (axisType === 'y') {
        const yColumns = chart.YAxisColumn ? chart.YAxisColumn.split(",") : [];
        if (chart.GroupColumn && chart.YAxisColumn) {
          yColumns.pop();
        }
        columnName = yColumns[0];
      } else if (axisType === 'z') {
        columnName = chart.ZAxisColumn;
      }

      if (!columnName) return false;

      const values = this.tableData[index]
        .map(item => item[columnName])
        .filter(value => typeof value === 'number' && !isNaN(value));

      return shouldFormatNumbers(values);
    },

    // Get formatted tick format for Plotly
    getFormattedTickFormat(chart, index, axisType) {
      const decimalPrecision = this.getDecimalPrecision(chart, 
        axisType === 'x' ? chart.XAxisColumn : 
        axisType === 'y' ? (chart.YAxisColumn ? chart.YAxisColumn.split(",")[0] : '') :
        chart.ZAxisColumn
      );

      if (this.shouldFormatAxisData(chart, index, axisType)) {
        // Use custom formatting function for large numbers
        return createCustomTickFormatter(decimalPrecision);
      }
      
      return `.${decimalPrecision}~f`;
    },

    getUOMForProperty(columnName, index) {
      // Get UOM from the first row of table data if available
      if (this.tableData && this.tableData[index] && this.tableData[index].length > 0) {
        const firstRow = this.tableData[index][0];
        const uomKey = `${columnName}_UOM`;
        if (firstRow && firstRow[uomKey] && firstRow[uomKey] !== 'data-not-available') {
          return firstRow[uomKey];
        }
      }
      return null;
    },

    formatAxisTitle(displayName, uom) {
      // Format axis title with UOM if available
      if (uom && uom.trim() !== '') {
        return `${displayName} (${uom})`;
      }
      return displayName;
    },

    convertToCsv(data, chartName) {
      const csvRows = [];
      const headers = ['Sample ID', 'Asset', 'Field', 'Well', 'Fluid Sample ID'].concat(Object.keys(data[0]).filter(header => header !== 'caption' && header !== '_id' && header !== 'uniqueID' && !header.endsWith('_decimal') && header !== 'field' && header !== 'asset'&& header !== 'well'));
      csvRows.push(headers.join(","));

      for (const row of data) {
        const values = headers.map((header) => {
          if (['Asset', 'Field', 'Well', 'Fluid Sample ID'].includes(header)) {
            return row.caption.split(',')[headers.indexOf(header) - 1];
          }
          if (header === 'Sample ID') {
            return row._id;
          }
          return JSON.stringify(row[header], (key, value) => value === null ? "" : value);
        });
        csvRows.push(values.join(","));
      }

      return csvRows.join("\n");
    },

  removePlotFromIndex(index, chart) {
    this.droppedCharts.splice(index, 1, null);
    this.tableData.splice(index, 1, []);
    this.selectedColorGroupKeys.splice(index, 1, '');
    this.selectedYAxisKeys.splice(index, 1, []);
    this.selectedXAxisKeys.splice(index, 1, []);
    this.selectedZAxisKeys.splice(index, 1, []);
    this.updatedXColumnDisplayName.splice(index, 1, '');
    this.updatedYColumnDisplayName.splice(index, 1, '');
    this.updatedGroupColumnDisplayName.splice(index, 1, '');
    this.isPreviewOpen.splice(index, 1, false);
    this.xBins.splice(index, 1, []);
    this.yBins.splice(index, 1, []);
    if (typeof this.loading !== 'object') {
        this.loading = {};
      }
    this.loading[index] = false;
    this.$emit('plot-removed', index);
    this.updateDashboard();
    eventBus.emit('chart-removed', chart);
  },

  // Setup legend click event handler for Plotly charts
  setupLegendClickHandler(chartDiv) {
    if (!chartDiv) {
      console.warn('Chart container not found for legend click handler');
      return;
    }

    // Ensure the chart container is a valid Plotly container
    if (typeof chartDiv.removeAllListeners !== 'function' || typeof chartDiv.on !== 'function') {
      console.warn('Chart container is not a valid Plotly container');
      return;
    }

    try {
      // Remove any existing event listeners to prevent duplicates
      chartDiv.removeAllListeners('plotly_legendclick');
      
      // Add legend click event listener
      chartDiv.on('plotly_legendclick', (event) => {
        // Get the clicked legend item
        const clickedItem = event.curveNumber;
        const traces = event.data;
        
        if (clickedItem !== undefined && traces && traces[clickedItem]) {
          const clickedTrace = traces[clickedItem];
          
          // Toggle visibility for only the clicked trace
          const updates = {};
          updates[`visible[${clickedItem}]`] = !clickedTrace.visible;
          
          // Apply the visibility change
          Plotly.restyle(chartDiv, updates);
        }
      });
    } catch (error) {
      console.error('Error setting up legend click handler:', error);
    }
  },
  },

  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
  },
  mounted() {
    eventBus.on("resizeChart", this.resizeAllCharts);
    // Add window resize listener for dynamic height calculation
    window.addEventListener('resize', this.handleResize);
    // this.loading = new Array(this.droppedCharts.length).fill(true);
  },

  beforeUnmount() {
    // Remove window resize listener
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
.drag-drop-zone.is-dragging {
  background-color: #f8fafc;
  border-color: #94a3b8;
}
</style>